import { render } from "./TheHeader.vue?vue&type=template&id=d348f7ce"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=d348f7ce&lang=scss"
script.render = render

export default script